import { App, Button, Form } from "antd";
import { useState } from "react";
import { ProgramBookingSetting } from "./ui/programBookingSetting";
import { ProgramOutline } from "./ui/programOutline";
import { ProgramTicketSetting } from "./ui/programTicketSetting";
import { ProgramOptionSetting } from "./ui/programOptionSetting";
import { useNavigate } from "react-router-dom";
import { useCreateProgramByCreateProgramAdminRequest } from "./model";
import { UploadFile } from "antd/lib";

interface IFormOutlineData {
  bookingPeriod: [string, string];
  description: string;
  detailHtml: string;
  detailImageUrlList: UploadFile[];
  isDisplay: boolean;
  isOnline: boolean;
  isAutoApprovalEnabled: boolean;
  isPaid: boolean;
  locationName: string;
  notificationHtml: string;
  onlineUrl?: string;
  refundNotiHtml: string;
  programPeriod: [string, string];
  roadNameAddress: IRoadNameAddress;
  thumbnailImageUrl: [UploadFile];
  title: string;
}

const ProgramCreate = () => {
  const [programEventOutlineList, setProgramEventOutlineList] = useState<
    IProgramEventOutline[]
  >([]);
  const [programTicketList, setProgramTicketList] = useState<IProgramTicket[]>(
    []
  );
  const [programSelectOptionList, setProgramSelectOptionList] = useState<
    IProgramSelectOption[]
  >([]);
  const [programSubjectOptionList, setProgramSubjectOptionList] = useState<
    IProgramSubjectOption[]
  >([]);
  const { message } = App.useApp();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const createProgramByCreateProgramAdminRequest =
    useCreateProgramByCreateProgramAdminRequest();
  const [isClickMockButton, setIsClickMockButton] = useState<boolean>(false);
  const [isPaidState, setIsPaidState] = useState<boolean>(true);

  const omitId = <T extends { id?: number }>(item: T): Omit<T, "id"> => {
    const { id, ...rest } = item;
    return rest;
  };

  const clickMockDataInput = () => {
    form.setFieldValue("isDisplay", true);
    form.setFieldValue("title", "Positive Retreat Program: Timeless Renewal");
    form.setFieldValue(
      "description",
      "Experience our Sound Therapy / Meditation of Positive Hotel with the one and only system"
    );
    form.setFieldValue("isPaid", true);
    form.setFieldValue("isOnline", false);
    form.setFieldValue("roadNameAddress", {
      address: "서울 강남구 도산대로 311 (신사동)",
      lat: 127.035349489973,
      lon: 37.5224100465581,
    });
    form.setFieldValue("locationName", "1층");
    form.setFieldValue(
      "thumbnailImageUrl",
      "https://img.positivehotel.io/2025/3/18/102448_PH_YOGA_Promotion_March_App_cover.jpg"
    );
    form.setFieldValue(
      "detailHtml",
      '<p>음악, 연극, 미술, 무용, 건축 등 다양한 분야의 혁신적인 문화 아이콘을 소개하는&nbsp;현대카드&nbsp;컬처프로젝트. 2011년부터 아티스트&nbsp;위켄드(The Weeknd),&nbsp;아리아나 그란데(Ariana Grande) 등의 공연과 영화감독&nbsp;팀 버튼(Tim Burton),&nbsp;스탠리 큐브릭(Stanley Kubrick) 등의 전시를 통해 세계적인 문화 예술 아이콘을 소개해 온 컬처프로젝트의 스물아홉 번째 주인공은 세계적인 조각가&nbsp;톰 삭스(Tom Sachs)다.</p><figure class="image image_resized" style="width:77.29%;"><img style="aspect-ratio:1125/1797;" src="https://img.positivehotel.io/2025/3/19/PH_YOGA_NEWYEAR_App_cover%20%282%29.jpg" width="1125" height="1797"></figure><p>이번 컬처프로젝트에서 선보일 톰 삭스의 전시 ＜스페이스 프로그램: 무한대＞는 2007년부터 시작된 그의 대표작 ＜스페이스 프로그램＞ 시리즈 200여 점을 포함해 최초 공개하는 신작 10여 점을 소개하는 역대 최대 규모의 전시가 될 예정이다. 우주를 향한 열정을 담아 상상력을 자극할 이번 전시, DIVE가 절대 놓쳐서는 안 될 다섯 가지 관람 포인트를 준비했다.</p>'
    );
    form.setFieldValue(
      "notificationHtml",
      "<ul><li>본 프로그램 기간은 파지티브호텔 사정에 따라 변경 또는 중단될 수 있습니다.</li><li>해피아워 할인 혜택은 딤섬 바 이용 고객에게만 적용되며, 홀 이용 고객에게는 적용되지 않습니다.</li><li>현대카드 바우처 및 M포인트 사용, 다른 할인 서비스 및 쿠폰, 이벤트 등의 혜택과 중복 적용이 불가합니다.</li><li>입장 시 연령 및 본인 확인 위한 신분증 지참 필수</li><li>발레파킹 서비스 2시간 무료 (주차 대행료 3000원 별도)</li></ul>"
    );
    form.setFieldValue(
      "refundNotiHtml",
      "<ul><li>본 프로그램 기간은 파지티브호텔 사정에 따라 변경 또는 중단될 수 있습니다.</li><li>해피아워 할인 혜택은 딤섬 바 이용 고객에게만 적용되며, 홀 이용 고객에게는 적용되지 않습니다.</li><li>현대카드 바우처 및 M포인트 사용, 다른 할인 서비스 및 쿠폰, 이벤트 등의 혜택과 중복 적용이 불가합니다.</li><li>입장 시 연령 및 본인 확인 위한 신분증 지참 필수</li></ul>"
    );
    setProgramEventOutlineList([
      {
        day: [2],
        id: 1,
        programEventList: [
          {
            id: 1,
            isActive: true,
            maxBookingCnt: 3,
            targetDateTime: "2025-03-25T11:00:00.000Z",
          },
          {
            id: 2,
            isActive: true,
            maxBookingCnt: 3,
            targetDateTime: "2025-04-01T11:00:00.000Z",
          },
          {
            id: 3,
            isActive: true,
            maxBookingCnt: 3,
            targetDateTime: "2025-04-08T11:00:00.000Z",
          },
          {
            id: 4,
            isActive: true,
            maxBookingCnt: 3,
            targetDateTime: "2025-04-15T11:00:00.000Z",
          },
        ],
        startTime: "20:00",
      },
      {
        day: [3],
        id: 2,
        programEventList: [
          {
            id: 1,
            isActive: true,
            maxBookingCnt: 3,
            targetDateTime: "2025-03-19T11:00:00.000Z",
          },
          {
            id: 2,
            isActive: true,
            maxBookingCnt: 3,
            targetDateTime: "2025-04-02T11:00:00.000Z",
          },
          {
            id: 3,
            isActive: true,
            maxBookingCnt: 3,
            targetDateTime: "2025-04-09T11:00:00.000Z",
          },
          {
            id: 4,
            isActive: true,
            maxBookingCnt: 3,
            targetDateTime: "2025-04-16T11:00:00.000Z",
          },
        ],
        startTime: "20:00",
      },
    ]);

    setProgramTicketList([
      {
        id: 1,
        name: "개인",
        description: "최소 1명부터 신청 가능합니다.",
        payAmount: 300000,
      },
      {
        id: 2,
        name: "프라이빗",
        description:
          "일행만 참여할 수 있는 프로그램 티켓입니다. 최소 3명부터 신청 가능합니다.",
        payAmount: 500000,
      },
      {
        id: 3,
        name: "VIP",
        description:
          "1일 대관 티켓으로 신청 후 이러저러한절차를 거치고 예약이 진행됩니다. 최소 6명부터 신청 가능합니다.",
        payAmount: 1000000,
      },
    ]);

    setProgramSelectOptionList([
      {
        id: 1,
        name: "프로그램",
        description: "원하는 프로그램을 선택해 주세요.",
        isRequired: true,
        idx: 0,
        programSelectOptionItemList: [
          { id: 1, name: "자연 속 호흡 명상: 감각깨우기" },
          { id: 2, name: "감정 카드 세션: 감정&감각 스캐닝" },
          { id: 3, name: "아로마 테라피" },
          { id: 4, name: "사운드배스 요가" },
          { id: 5, name: "깊은 이완 요가 : 인요가" },
        ],
      },
      {
        id: 2,
        name: "밀(Meal) 타입",
        description: "선호하시는 밀 타입을 선택해 주세요.",
        isRequired: true,
        idx: 1,
        programSelectOptionItemList: [
          { id: 1, name: "누들" },
          { id: 2, name: "보울" },
        ],
      },
    ]);
    setProgramSubjectOptionList([
      {
        id: 1,
        name: "알러지",
        idx: 0,
        description: `특정 음식에 알러지가 있으시다면 알려주세요. 없으시다면 ‘없음' 으로 적어주세요.`,
        isRequired: true,
      },
    ]);
    setIsClickMockButton(true);
  };
  const onFinish = (value: IFormOutlineData) => {
    const createProgramAdminRequest: ICreateProgramAdminRequest = {
      isDisplay: value.isDisplay,
      title: value.title,
      description: value.description,
      isPaid: value.isPaid,
      isAutoApprovalEnabled: value.isAutoApprovalEnabled,
      isOnline: value.isOnline,
      onlineUrl: value.onlineUrl,
      roadNameAddress: value.roadNameAddress,
      locationName: value.locationName,
      detailHtml: value.detailHtml,
      notificationHtml: value.notificationHtml,
      refundNotiHtml: value.refundNotiHtml,
      programPeriod: value.programPeriod,
      bookingPeriod: value.bookingPeriod,
      thumbnailImageFile: value.thumbnailImageUrl[0]?.originFileObj,
      detailImageFileList: value.detailImageUrlList.map((q) => q.originFileObj),
      programEventOutlineList:
        programEventOutlineList?.map((q) => {
          const newRest = omitId(q);
          return {
            ...newRest,
            programEventList: newRest.programEventList?.map(omitId) ?? [],
          };
        }) ?? [],
      programTicketList: programTicketList?.map(omitId) ?? [],
      programSelectOptionList:
        programSelectOptionList?.map((q) => {
          const newRest = omitId(q);
          return {
            ...newRest,
            programSelectOptionItemList:
              newRest.programSelectOptionItemList?.map(omitId) ?? [],
          };
        }) ?? [],
      programSubjectOptionList: programSubjectOptionList?.map(omitId) ?? [],
    };
    if (
      (createProgramAdminRequest?.programEventOutlineList?.[0]?.programEventList
        ?.length ?? 0) <= 0
    ) {
      message.error("예약설정 중 회차를 추가해주세요");
    } else if (
      createProgramAdminRequest?.isPaid &&
      (createProgramAdminRequest?.programTicketList?.length ?? 0) <= 0
    ) {
      message.error("티켓을 추가해주세요");
    } else {
      createProgramByCreateProgramAdminRequest.mutate(
        createProgramAdminRequest,
        {
          onSuccess: (res) =>
            !res.data.errors
              ? navigate("/wellness-program/program")
              : message.error(
                "에러가 발생했습니다 개발팀에 문의해주세요  " +
                res.data.errors[0].message
              ),
        }
      );
    }
  };

  return (
    <>
      <div style={{ position: "relative" }}>
        <div
          style={{
            position: "absolute",
            right: 0,
            top: "-40px",
            display: "flex",
            gap: "10px",
          }}
        >
          <div onClick={() => clickMockDataInput()}>Mock</div>
        </div>
      </div>
      <Form
        form={form}
        labelCol={{ span: 3 }}
        labelAlign="left"
        colon={false}
        onFinish={onFinish}
        requiredMark={false}
      >
        <ProgramOutline isDefalutOpen setIsPaidState={setIsPaidState} />

        <div style={{ position: "relative", height: "24px" }}>
          <div
            style={{
              position: "absolute",
              left: "-20px",
              width: "calc(100% + 40px)",
              height: "24px",
              backgroundColor: "var(--ant-layout-footer-bg)",
            }}
          />
        </div>

        <ProgramBookingSetting
          key={`booking-${isClickMockButton}`}
          programEventOutlineList={programEventOutlineList}
          setProgramEventOutlineList={setProgramEventOutlineList}
          isDefalutOpen
        />

        <div style={{ position: "relative", height: "24px" }}>
          <div
            style={{
              position: "absolute",
              left: "-20px",
              width: "calc(100% + 40px)",
              height: "24px",
              backgroundColor: "var(--ant-layout-footer-bg)",
            }}
          />
        </div>

        {isPaidState && (
          <ProgramTicketSetting
            key={`ticket-${isClickMockButton}`}
            initProgramTicketList={programTicketList}
            setProgramTicketList={setProgramTicketList}
            isDefalutOpen
          />
        )}

        <div style={{ position: "relative", height: "24px" }}>
          <div
            style={{
              position: "absolute",
              left: "-20px",
              width: "calc(100% + 40px)",
              height: "24px",
              backgroundColor: "var(--ant-layout-footer-bg)",
            }}
          />
        </div>

        <ProgramOptionSetting
          key={`option-${isClickMockButton}`}
          initProgramSelectOptionList={programSelectOptionList}
          setProgramSelectOptionList={setProgramSelectOptionList}
          initProgramSubjectOptionList={programSubjectOptionList}
          setProgramSubjectOptionList={setProgramSubjectOptionList}
          isDefalutOpen
        />

        <div style={{ position: "relative", height: "24px" }}>
          <div
            style={{
              position: "absolute",
              left: "-20px",
              width: "calc(100% + 40px)",
              height: "24px",
              backgroundColor: "var(--ant-layout-footer-bg)",
            }}
          />
        </div>

        <div
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
            margin: "335px 0 -55px -40px",
            padding: "20px 40px",
            display: "flex",
            justifyContent: "space-between",
            width: "calc(100% + 80px)",
          }}
        >
          <Button
            disabled={createProgramByCreateProgramAdminRequest.isPending}
            onClick={() => navigate("/wellness-program/program")}
          >
            취소
          </Button>
          <Button
            loading={createProgramByCreateProgramAdminRequest.isPending}
            htmlType="submit"
            type="primary"
          >
            저장
          </Button>
        </div>
      </Form>
    </>
  );
};

export { ProgramCreate };
